const PHONE_REG = /^13(\d{9})$|^15(\d{9})$|^14(\d{9})$|^17(\d{9})$|^18(\d{9})$/;

export default class Verify {
  // 验证为空
  static isNull(str) {
    if (str == null) return true;
    if (typeof str === "string" || Array.isArray(str)) {
      return str.length === 0;
    }
    return false;
  }
  static isNull1(form, vue) {
    var flag = true;
    // (() => {})(form, vue);
    vue.$refs[form][0].validate((valid) => {
      // (() => {})(valid);
      if (valid || valid === 0 || valid === "0") {
        flag = true;
      } else {
        flag = false;
        // vue.$message.error(vue.$t("src.utils.tool.52h1nf954bs0"));
      }
    });
    return flag;
  }
  // 验证手机号
  static isPhone(str) {
    return PHONE_REG.test(str);
  }

  static isPhoneTips(phone) {
    if (this.isNull(phone)) {
      return "手机号不能为空";
    } else if (!PHONE_REG.test(phone)) {
      return "手机号格式不正确";
    }
  }

  static isPwd(str) {
    return /^[\w]{6,12}$/.test(str);
  }

  static isPwdTips(pwd, tips) {
    const reg = /^[\w]{6,12}$/;
    if (this.isNull(pwd)) {
      return tips + "不能为空";
    } else if (!reg.test(pwd)) {
      return tips + "格式不正确";
    }
  }

  // 验证身份证
  static isSFZ(sfz) {
    return /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/.test(
      sfz
    );
  }
  // 验证银行卡
  static isYHK(yhk) {
    return /^([\d]{4})([\d]{4})([\d]{4})([\d]{4})([\d]{0,})?/.test(yhk);
  }

  static isEmail(email) {
    return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email);
  }
  // 获取localstorage
  static getStorage(key) {
    const value = window.localStorage.getItem(key);
    if (value == null) return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
  // 设置localstorage
  static setStorage(key, v) {
    localStorage.setItem(key, JSON.stringify(v));
  }
  // 添加新key到localstorage
  static addStorage(key, addedV) {
    let oldVal = this.getStorage(key);
    let newVal =
      oldVal && typeof oldVal === "object"
        ? Object.assign(oldVal, addedV)
        : Object.assign({}, addedV);
    this.setStorage(key, newVal);
  }
  // 移除localstorage
  static removeStorage(key) {
    localStorage.removeItem(key);
  }
  //信息成功
  static successTip(tips) {
    this.$message({
      message: tips,
      type: "success",
    });
  }
  //信息警告
  static warningTip(tips) {
    this.$message({
      message: tips,
      type: "warning",
    });
  }
  //信息失败
  static errorTip(tips) {
    this.$message.error(tips);
  }
  //获取？号参数
  static getQueryString(name) {
    return this.getParameter(name);
  }
  // 获取表格高度
  static getTableHeight(num) {
    var clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
      clientHeight =
        document.body.clientHeight < document.documentElement.clientHeight
          ? document.body.clientHeight
          : document.documentElement.clientHeight;
    } else {
      clientHeight =
        document.body.clientHeight > document.documentElement.clientHeight
          ? document.body.clientHeight
          : document.documentElement.clientHeight;
    }
    return clientHeight - num;
  }
  //自定编辑列方式*******设置自定义编辑内容展示数据
  static settingOprateData(fieldColumns) {
    var arr = [];
    var arr2 = [];
    var obj = {};
    // fieldColumns//后台传过来的数据列
    fieldColumns.forEach((item, index) => {
      arr.push({
        key: index,
        label: item.fieldname,
        disabled: item.custom == "0",
      });
      if (item.show == "0") {
        arr2.push(index);
      }
    });
    obj.data = arr;
    obj.oprateColumn = arr2;
    return obj;
  }
  static getParameter(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  }

  static formatDate(time, format = 'YY-MM-DD hh:mm:ss') {
    const date = time ? new Date(time) : new Date();

    const year = date.getFullYear(),
      month = date.getMonth() + 1,//月份是从0开始的
      day = date.getDate(),
      hour = date.getHours(),
      min = date.getMinutes(),
      sec = date.getSeconds();
    const preArr = Array.apply(null, Array(10)).map(function (elem, index) {
      return '0' + index;
    });

    const newTime = format.replace(/YY/g, year)
      .replace(/MM/g, preArr[month] || month)
      .replace(/DD/g, preArr[day] || day)
      .replace(/hh/g, preArr[hour] || hour)
      .replace(/mm/g, preArr[min] || min)
      .replace(/ss/g, preArr[sec] || sec);

    return newTime;
  }
}
